import React, { useContext } from "react";
import { Context } from "../../layouts/context";
import QuoteForm from "./QuoteForm";
import { Modal, ModalHeader, ModalTitle, ModalSubTitle,  ModalDialog, ModalContent, ModalBody, ModalBackdrop, CloseButton } from "../Modal"
import CloseIcon from '../Icons/CloseIcon';

const QuotePopUp = ({ location }) => {
  const { popupContext, setPopupContext } = useContext(Context);

  return (
    <>
      <Modal className="modal" hidden={!popupContext.isVisible}>
        <ModalDialog className="modal-dialog modal-dialog-centered">
          <ModalContent className="modal-content">
            <ModalHeader class="modal-header">
              <ModalTitle className="modal-title">Get In Touch</ModalTitle>
              <ModalSubTitle>We not only fulfill your metal building needs, but we also make dreams come true.</ModalSubTitle>
              <CloseButton type="button" className="close" onClick={() => setPopupContext({
                isVisible: false
              })}><CloseIcon /></CloseButton>
            </ModalHeader>
            <ModalBody className="modal-body">
              <QuoteForm location={location} />
            </ModalBody>
          </ModalContent>
        </ModalDialog>
      </Modal>
      <ModalBackdrop hidden={!popupContext.isVisible} />
    </>
  );
};

export default QuotePopUp;
